import Axios from "axios";
import {
    SET_PROJECT_TRAINING_LIST,
    UNSET_PROJECT_TRAINING_LIST
} from "@/store/mutation-types";

import { saveUpdateProjectTraining, getProjectTrainingList } from "@/store/api";
// initial state
const state = {
    getProjectTrainingList: [],
};

const getters = {
    getProjectTrainingList(state) {
        return state.getProjectTrainingList;
    }
};

const mutations = {
    [SET_PROJECT_TRAINING_LIST](state, data) {
        state.getProjectTrainingList = data;
    }   
,
    [UNSET_PROJECT_TRAINING_LIST](state) {
        state.getProjectTrainingList = [];
    }
};


const actions = {
    saveUpdateProjectTraining({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateProjectTraining, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getProjectTrainingList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getProjectTrainingList, data)
                .then(function (response) {
                    commit('SET_PROJECT_TRAINING_LIST', response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_PROJECT_TRAINING_LIST');
                    reject(error);
                });
        });
    }
};


export default {
    state,
    getters,
    actions,
    mutations       
};